
import { Options, prop, Vue } from "vue-class-component";
import { getPhoneDisplayCode } from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import { AccountController } from "@/app/ui/controllers/AccountController";
import SelectPhoneCountry from "@/app/ui/views/shipment/booking/component/select-phone-country.vue";

export type ContactInformationSectionProp = {
  name: string;
  level: string;
  phone: string;
  phoneDialCode?: string;
  email: string;
};

export type ContactInformationSectionErrorProp = {
  contactPhone: boolean;
  contactEmail: boolean;
};

class Props {
  modelValue = prop<ContactInformationSectionProp>({
    default: {
      email: "",
      level: "",
      name: "",
      phone: "",
      phoneDialCode: ""
    }
  });
  error = prop<ContactInformationSectionErrorProp>({
    default: {
      contactEmail: false,
      contactPhone: false
    }
  });
  isMY = prop<boolean>({
    default: false
  });
}

class ContactInformationSection extends Vue.with(Props) {
  get prefix() {
    return this.isMY ? "+60" : "+62";
  }

  get formModel() {
    return this.modelValue;
  }

  set formModel(val) {
    this.$emit("update:modelValue", val);
  }

  get formErrorModel() {
    return this.error;
  }

  set formErrorModel(val) {
    this.$emit("update:error", val);
  }

  validatePhone(value: string) {
    this.formErrorModel.contactPhone = !/^\d+$/.test(value) || value.length < 8;
    if (this.isMY) this.formErrorModel.contactPhone = !/^\d+$/.test(value);
  }

  formatNumber(value: string) {
    const newValue = value.replace(/^62|^60|^0|[\D]+/g, "");
    return newValue.startsWith("0")
      ? newValue.slice(1, newValue.length)
      : newValue;
  }

  validateEmail(value: string) {
    this.formErrorModel.contactEmail = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
      value
    );
  }
}
export default ContactInformationSection;
